import { ChangeEvent } from "react"
import { InvoiceDetailsInterface } from "../stateReducers/invoiceSlice"

export interface ExtraItemInterface {
    id: number,
    quantity: number,
    description: string
}

export interface GunInterface {
    id: number,
    quantity: number,
    description: string
}

export interface StepProps {
    setStepValidity: (isValid: boolean) => void,
}

export interface FormStateInterface {
    step: number
}

export interface deliveryOptionsInterface extends bookingDatesInterface {
    deliveryType: string | null,
    playStart: Date | null,
    playEnd: Date | null,
    deliveryDate?: Date | null,
    rentalPoint?: number,
    homeAddress?: string,
    building?: string,
    buildingDetails?: string,
    transforceComments?: string,
    insuranceAddress?: string
    returnDate?: Date | null,
    dpdPoint: DPDPoint | null,
    dpdSearchAddress: string | null,
}

export interface gunOptionsInterface {
    gunType: string | null,
    quantity: number | null,
}

export interface bookingDatesInterface {
    startDate?: Date | null,
    endDate?: Date | null
}

type Delivery = "delivery" | "transforce" | "dpd";
type AvailabilityObject = {
    [key in number | Delivery]: boolean
}
export interface AvailabilityInterface extends AvailabilityObject, Date {
}

export interface extraItemBookingInterface {
    type: string,
    quantity: number
}

export interface extraItemsInterface {
    items: extraItemBookingInterface[]
}


export interface ExtraItemSliceInterface extends extraItemsInterface {
    freeDeliverySwitch: boolean
}

export interface customerDetailsInterface {
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    activity: string,
    coupon?: string,
    needInvoice?: boolean,
    subscribe: boolean,
}

export interface languageInterface {
    lang: string
}

export interface referrerInterface {
    referrer: string
}

export type FormType = "Default" | "YouthPromo" | "LaserOnly" | "BowOnly";

export interface BookingInterface extends gunOptionsInterface, deliveryOptionsInterface, ExtraItemSliceInterface, customerDetailsInterface, bookingDatesInterface, languageInterface, referrerInterface, InvoiceDetailsInterface {
    formType: FormType,
    domain: string,
}

export interface rentalPointScheduleInterface {
    [key: number]: Day[]
}

export interface rentalPointDataInterface {
    image?: string,
    imageFr?: string,
    description?: string,
    translationKey?: string
}

export interface rentalPointsDataInterface {
    [key: number]: rentalPointDataInterface
}

interface FreeDeliveryPagesListInterface {
    [key: string]: string[]
}

export interface JsonInterval {
    start: string,
    end: string
}

export interface PromotionInterval extends JsonInterval {
    name: string,
    languages?: string[],
    description?: string,
    descriptionFr?: string,
    bannerImgNl?: string,
    bannerImgFr?: string,
    promotion?: GunTypePromoMatrix,
    extension: boolean | number,
    customCodeHooks?: string[],
}

export interface GunTypePromoMatrix {
    phoenix?: DeliveryTypePromoMatrix,
    brx?: DeliveryTypePromoMatrix,
    childBow?: DeliveryTypePromoMatrix,
    adultBow?: DeliveryTypePromoMatrix,
    bow?: DeliveryTypePromoMatrix,
}

export interface DeliveryTypePromoMatrix {
    ///// Delivery
    dpd?: PromoMatrix,
    transforce?: PromoMatrix,
    transforceDpd?: PromoMatrix,

    ///// Rental
    // Most specific
    herent?: PromoMatrix,
    hasselt?: PromoMatrix,
    aalst?: PromoMatrix,
    beerse?: PromoMatrix,
    brugge?: PromoMatrix,
    brussel?: PromoMatrix,
    gent?: PromoMatrix,
    merksem?: PromoMatrix,
    poelkapelle?: PromoMatrix,
    
    // More general
    homePoints?: PromoMatrix,
    otherPoints?: PromoMatrix,
    
    // Most general
    rental?: PromoMatrix
}

export interface PromoMatrix {
    freeItems?: FreeItem[],
    deliveryPromos?: DeliveryPromo[]
}

// export interface FreeItemMatrix {
//     laser?: FreeItem[],
//     phoenix?: FreeItem[],
//     brx?: FreeItem[],
//     bow?: FreeItem[]
// }

export interface FreeItem {
    name: string,
    quantity: number,
    isExtra: boolean,

    // Min quantity of gunOptions item before the promo is applied
    minQuantity?: number,
    
    // For if there is advanced behavior required for the promotion
    customCodeHooks?: string[]
}

export interface DeliveryPromo {
    deliveryType: DeliveryType,
    minQuantity: number,
    maxQuantity?: number,

    // For if there is advanced behavior required for the promotion
    customCodeHooks?: string[]
}

export interface HolidaysInterface {
    holidays: RentalPointHolidayInterface,
    globalHolidays: string[],
    deliveryHolidays: string[]
}

interface RentalPointHolidayInterface {
    [key: number]: string[]
}

export type youthMinimumQuantity = {
    phoenix: number,
    brx: number,
    childBow: number,
    adultBow:number
}
export interface bookingConfig extends HolidaysInterface {
    country?:string,
    IMinimumAmountGunsForAFreeDeliveryInCertainRegions: number,
    IFreeDeliveryFromNumberOfLaserGuns: number,
    INumberOfLaserGunsNotAllowedToReserveInRentalPoints: number,
    freeDeliveryInterval: JsonInterval[],
    discount50DeliveryInterval: JsonInterval[],
    promoIntervals: PromotionInterval[],
    standardPromotion: GunTypePromoMatrix,
    rentalPointSchedule: rentalPointScheduleInterface,
    rentalPointData: rentalPointsDataInterface,
    holidayFreeTransforceDeliveryPhoenixQuantity: number,
    askGeoConsent: boolean,
    possibleFreeDeliveryLabel: boolean,
    freeZips: string[],
    FreeDeliveryPagesList: FreeDeliveryPagesListInterface,
    youthMovementPromotionInterval: JsonInterval[],
    phoenixLargeOrderThreshold:number,
    brxLargeOrderThreshold:number,
    bowsLargeOrderThreshold:number,
    youthMinimumQuantity: youthMinimumQuantity,
    shippingCosts: {
        default: {[shippingName: string]: number}
        phoenix: {[deliveryType: string]: {[amount: string] : number}}
    },
    exceptionallyOpen: RentalPointHolidayInterface,
    inflatableObjectsAltImage: string,
    maxPhoenixDpdQuantity: any
}

export interface DPDPointWorkingSchedule {
    weekday: string,
    openMorning: string,
    closeMorning: string,
    openAfternoon: string,
    closeAfternoon: string
}

export interface DPDPoint {
    id: string,
    lat: number,
    lng: number,
    name: string,
    address: string,
    zip: string,
    company?: string,
    schedule: DPDPointWorkingSchedule[]
}

export interface Coord {
    lat: number,
    lng: number
}

export enum DPDPointDeliveryType {
    Free = 'free',
    ProbablyFree = 'probablyFree',
    DPDPoint = '15euro',
    DPDPoint50Discount = '15euro50discount'
}

export enum TransforceDPDDeliveryType {
    DPD = '20euro',
    DPDFree = '20euroFree',
    DPD50Discount = '20euro50discount'
}

export enum TransforceDeliveryType {
    Transforce = '30euro',
    TransforceBow = '25euro',
    TransforceFree = '30euroFree',
    Transforce50Discount = '30euro50discount'
}

export enum HalfOffDeliveryType {
    DPDPoint50Discount = '15euro50discount',
    DPD50Discount = '20euro50discount',
    Transforce50Discount = '30euro50discount',
}

/**
 * This should be the union of all possible other delivery types
 */
export enum DeliveryType {
    // DPDPointDeliveryType
    Free = 'free',
    ProbablyFree = 'probablyFree',
    DPDPoint = '15euro',
    DPDPoint50Discount = '15euro50discount',

    // TransforceDPDDeliveryType
    DPD = '20euro',
    DPDFree = '20euroFree',
    DPD50Discount = '20euro50discount',

    // TransforceDeliveryType
    Transforce = '30euro',
    TransforceBow = '25euro',
    TransforceFree = '30euroFree',
    Transforce50Discount = '30euro50discount'
}

export interface inputProps {
    label: string,
    labelText: string,
    useLabelTextAsHtml?: boolean,
    onChange?: (event: ChangeEvent<HTMLInputElement>|ChangeEvent<HTMLSelectElement>) => void,
    required: boolean,
    redHighlight: boolean,
    additionalClassNames?: string,
    additionalNote?: string,
    // refList?: MutableRefObject<{[label: string]: RefObject<HTMLInputElement | HTMLSelectElement>}>,
    // refIndexByLabel?: (label: string) => number | undefined,
    inputDisabled?: boolean
}
